module.exports = __webpack_public_path__ + "img/container_lagermeister.73b2dac2.png";